import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Button, Form, Modal, Pagination } from "react-bootstrap";
import SuppliersTableRow from "./SuppliersTableRow";
import AxiosController from "../../../authentication/AxiosController";
import Loader from "../../../loader/Loader";
import { Helmet } from "react-helmet";
import Select from 'react-select';

const get_warehouses = (
  slug,
  lang,
  token,
  handleWarehouses,
  courierId,
  page,
  handleLoader
) => {
  AxiosController.get(
    `api/${slug}/${lang}/couriers/get-courier-data/${courierId}/${page}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      handleWarehouses(res.data);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};
const get_warehouses2 = (
  slug,
  lang,
  token,
  handleWarehouses,
  courierId,
  handleLoader
) => {
  AxiosController.get(
    `api/${slug}/${lang}/couriers/get-courier/${courierId}/`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      handleWarehouses(res.data);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const get_shippingcosts = (
  slug,
  lang,
  token,
  shippingcostsHandler,
  handleLoader
) => {
  AxiosController.get(`api/${slug}/${lang}/get-shippingcost/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      shippingcostsHandler(res.data);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const createWarehouse = (
  slug,
  lang,
  token,
  courierId,
  govIds,
  cost,
  handling,
  extra_handling,
  cancellation_fee,
  handleLoader,
  setShow,
  handleSuppliers,
  isEditing,
  govId
) => {
  handleLoader(true);
  const endpoint = isEditing 
    ? `api/${slug}/${lang}/couriers/update-courier-government/${govId}`
    : `api/${slug}/${lang}/couriers/courier-governments-data/`;

  const data = isEditing
    ? {
        courier_id: courierId,
        gov_id: govIds[0].value,
        cost,
        handling,
        extra_handling,
        cancellation_fee,
      }
    : {
        courier_id: courierId,
        gov_ids: govIds.map(option => option.value),
        cost,
        handling,
        extra_handling,
        cancellation_fee,
      };

  AxiosController.post(
    endpoint,
    data,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      get_warehouses(
        slug,
        lang,
        token,
        handleSuppliers,
        courierId,
        1,
        handleLoader
      );
      setShow(false);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const Courier = () => {
  const { slug, lang, courierId } = useParams();
  const location = useLocation();
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [suppliers, handleSuppliers] = useState([]);
  const [loading, handleLoader] = useState(false);
  const [cost, setCost] = useState(0);
  const [handling, setHandling] = useState(0);
  const [extraHandling, setExtraHandling] = useState(0);
  const [cancellation_fee, setCancellation_fee] = useState(0);
  const [show, setShow] = useState(false);
  const [shippingCosts, setShippingCosts] = useState([]);
  const [courier, setCourier] = useState({});
  const [selectedGovIds, setSelectedGovIds] = useState([]);
  const [page, handlePage] = useState(urlParams.get("page") || 1);
  const [isEditing, setIsEditing] = useState(false);
  const [editingGovId, setEditingGovId] = useState(null);

  const handleSelectAll = () => {
    const allOptions = shippingCosts.map((gov) => ({
      value: gov.id,
      label: `${gov.arabic_name} - ${gov.cost}`
    }));
    setSelectedGovIds(allOptions);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setSelectedGovIds([]);
  };

  const handleShow = () => {
    setShow(true);
    setIsEditing(false);
  };

  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const changeParam = (param, value) => {
    urlParams.set(param, value);
    Navigate(`?${urlParams.toString()}`);
  };
  useEffect(() => {
    handleLoader(true);
    const nextPage = parseInt(urlParams.get("page"), 10) || 1;
    handlePage(nextPage);
    get_shippingcosts(slug, lang, token, setShippingCosts, handleLoader);
    get_warehouses(
      slug,
      lang,
      token,
      handleSuppliers,
      courierId,
      nextPage,
      handleLoader
    );
    get_warehouses2(slug, lang, token, setCourier, courierId, handleLoader);
  }, [slug, lang, location.search]);

  return (
    <div
      className="position-relative tables-container"
      style={{ minHeight: "100px", width: "100%" }}
    >
      {" "}
      <Helmet>
        <title>{_("panel.courier")}</title>
      </Helmet>
      <Button
        variant="primary"
        onClick={() => {
          setCost(0);
          setHandling(0);
          setExtraHandling(0);
          setCancellation_fee(0);
          setSelectedGovIds([]);
          setIsEditing(false);
          setEditingGovId(null);
          handleShow(true);
        }}
        style={{ background: "#59C6C9", color: "white", border: "none" }}
      >
        {_("panel.add")}
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">{isEditing ? _("panel.edit") : _("panel.add")}</Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
          <label htmlFor="exampleInputEmail1" className="form-label">
            {_("home.province")}
          </label>
          <Form.Group className="mb-3 flex-grow-1">
            <Select
              isMulti={!isEditing}
              value={selectedGovIds}
              options={[
                { value: 'all', label: _('Select All') },
                ...shippingCosts.map((gov) => ({
                  value: gov.id,
                  label: `${gov.arabic_name} - ${gov.cost}`
                }))
              ]}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(selectedOptions) => {
                if (!isEditing) {
                  const lastSelected = selectedOptions[selectedOptions.length - 1];
                  if (lastSelected?.value === 'all') {
                    setSelectedGovIds(shippingCosts.map((gov) => ({
                      value: gov.id,
                      label: `${gov.arabic_name} - ${gov.cost}`
                    })));
                  } else {
                    setSelectedGovIds(selectedOptions.filter(option => option.value !== 'all'));
                  }
                }
              }}
            />
          </Form.Group>
          {label_input(_("panel.cost"), cost, setCost)}
          {label_input("handling", handling, setHandling)}
          {label_input("extra handling", extraHandling, setExtraHandling)}
          {label_input(
            "Cancellation fee",
            cancellation_fee,
            setCancellation_fee
          )}
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button
            variant="primary"
            onClick={() => {
              createWarehouse(
                slug,
                lang,
                token,
                courierId,
                selectedGovIds,
                cost,
                handling,
                extraHandling,
                cancellation_fee,
                handleLoader,
                setShow,
                handleSuppliers,
                isEditing,
                editingGovId
              );
            }}
          >
            {isEditing ? _("panel.update") : _("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader active={loading} />
      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${lang === "en" ? "flex-row" : "flex-row"
            } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.courier")}{" "}
            <span style={{ color: "rgb(243, 168, 55)" }}>{courier?.name}</span>
          </h3>
        </div>
        <div className="footer d-flex flex-column flex-grow-1">
          {suppliers.data ? (
            <SuppliersTableRow
              payments_list={suppliers.data}
              handleLoader={handleLoader}
              setShow={setShow}
              setCost={setCost}
              setGovId={setSelectedGovIds}
              setHandling={setHandling}
              setExtraHandling={setExtraHandling}
              setCancellation_fee={setCancellation_fee}
              setIsEditing={setIsEditing}
              setEditingGovId={setEditingGovId}
            />
          ) : (
            ""
          )}
          {suppliers.data ? (
            <Pagination
              className="m-auto flex-wrap"
              dir={lang === "ar" ? "ltr" : ""}
            >
              <Pagination.First onClick={() => changeParam("page", 1)} />
              <Pagination.Prev
                onClick={() =>
                  page - 1 > 0 ? changeParam("page", page - 1) : 1
                }
              />
              {suppliers["links"].map((element, index, arr) => {
                if (index == 0 || arr.length - 1 == index) {
                  return "";
                } else {
                  return (
                    <Pagination.Item
                      active={element["active"] ? true : false}
                      onClick={(e) =>
                        element["label"] != "..."
                          ? changeParam("page", parseInt(element["label"]))
                          : ""
                      }
                    >
                      {element["label"]}
                    </Pagination.Item>
                  );
                }
              })}
              <Pagination.Next onClick={() => changeParam("page", page + 1)} />
              <Pagination.Last
                onClick={() => changeParam("page", suppliers["last_page"])}
              />
            </Pagination>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
const label_input = (label, newWarehouseName, handleNewWarehouseName) => {
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={newWarehouseName}
        onInput={(e) => handleNewWarehouseName(e.target.value)}
      />
    </div>
  );
};
export default Courier;
